import { useCallback, useEffect, useState } from "react";
import { listPenalties, penaltyReasons, penaltyTypes } from "../../api/penalties";
import { listBranches, listUsers } from "../../api/directory";
import { listDepartments } from "../../api/departments";

const EMPTY = { user_id: "", branch_id: "", type: "", status: "", from_date: "", to_date: "" };

// كل بيانات صفحة العقوبات في مكان واحد: الفلاتر + القوائم المرجعية.
export const usePenalties = () => {
  const [filters, setFilters] = useState(EMPTY);
  const [rows, setRows] = useState([]);
  const [types, setTypes] = useState({});
  const [reasons, setReasons] = useState({});
  const [employees, setEmployees] = useState([]);
  const [branches, setBranches] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refsLoaded, setRefsLoaded] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    const params = Object.fromEntries(Object.entries(filters).filter(([, v]) => v));
    const data = await listPenalties(params);
    setRows(data.items || []);
    setLoading(false);
  }, [filters]);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    Promise.all([
      penaltyTypes().then((d) => setTypes(d.types || {})),
      penaltyReasons().then((d) => setReasons(d.reasons || {})),
      listUsers(null, "active").then(setEmployees),
      listBranches().then(setBranches).catch(() => setBranches([])),
      listDepartments().then(setDepartments).catch(() => setDepartments([])),
    ]).finally(() => setRefsLoaded(true));
  }, []);

  return { filters, setFilters, rows, types, reasons, employees, branches, departments, loading, refsLoaded, reload: load };
};
